<!-- TopMenu.vue -->
<template>
  <div class="topMenu p-2 d-flex flex-column" style="background-color: #e7e7e2">
    <div
      role="group"
      aria-labelledby="general-actions-label"
      class="d-flex flex-wrap justify-content-start"
    >
      <span id="general-actions-label" class="sr-only"
        >General search actions</span
      >
      <b-button
        v-if="category != 'descriptions' && category != 'annotations'"
        size="sm"
        class="mr-2"
        @click="handleNewSearch"
        >New Search</b-button
      >
      <b-button
        v-if="category != 'community'"
        size="sm"
        class="mr-2"
        @click="handleDownload('all')"
        >Download All</b-button
      >
      <b-button
        v-if="category != 'community'"
        size="sm"
        class="mr-2"
        @click="handleDownload('checked')"
        >Download Checked</b-button
      >
    </div>

    <div
      role="group"
      aria-labelledby="gene-actions-label"
      class="d-flex flex-wrap justify-content-start mt-2"
      v-if="category == 'genes'"
    >
      <span id="gene-actions-label" class="sr-only">Gene-specific actions</span>
      <b-button
        v-if="category == 'genes'"
        size="sm"
        @click="handleGoSearch"
        class="mr-2"
        >Get GO Annotations</b-button
      >
      <b-button
        v-if="category == 'genes'"
        size="sm"
        @click="handlePoSearch"
        class="mr-2"
        >Get PO Annotations</b-button
      >

      <b-button
        v-if="category == 'genes'"
        size="sm"
        @click="handleGetSequences"
        class="mr-2"
        aria-haspopup="dialog"
        >Get Sequences</b-button
      >
      <b-button
        v-if="category == 'genes'"
        size="sm"
        @click="handleGetDescriptions"
        class="mr-2"
        >Get Gene Descriptions</b-button
      >
      <b-button
        v-if="category == 'genes'"
        size="sm"
        @click="handleLocusHistory"
        class="mr-2"
        >Get Locus History</b-button
      >
    </div>

    <!-- Live region for screen reader announcements -->
    <div class="sr-only" aria-live="polite" aria-atomic="true">
      {{ announcement }}
    </div>

    <!-- <b-button
      v-if="category == 'genes'"
      size="sm"
      @click="$emit('get-checked-sequences')"
      >Get Checked Sequences</b-button
    > -->
  </div>
</template>

<script>
export default {
  props: {
    category: String,
  },
  data() {
    return {
      announcement: "",
    };
  },
  methods: {
    handleNewSearch() {
      this.announcement = "Navigating to new search page.";
      this.$emit("new-search");
    },
    handleDownload(type) {
      this.announcement = `Downloading ${type} results.`;
      this.$emit("download-csv", { category: this.category, type });
    },
    handleGoSearch() {
      this.announcement = "Fetching GO annotations.";
      this.$emit("go-search");
    },
    handlePoSearch() {
      this.announcement = "Fetching PO annotations.";
      this.$emit("po-search");
    },
    handleGetSequences() {
      this.announcement = "Getting sequences.";
      this.$emit("get-sequences");
    },
    handleGetDescriptions() {
      this.announcement = "Getting gene descriptions.";
      this.$emit("get-descriptions");
    },
    handleLocusHistory() {
      this.announcement = "Getting locus history.";
      this.$emit("get-locus-history");
    },
  },
};
</script>

<style scoped>
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.topMenu {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  /* border: 2px solid red;  Uncomment for debugging */
}

.d-flex.flex-wrap {
  min-width: 0;
  max-width: 100%;
  gap: 0.5rem;
}

/* Ensure buttons wrap properly on small screens */
@media (max-width: 480px) {
  .topMenu {
    padding: 0.5rem !important;
  }

  .d-flex.flex-wrap {
    gap: 0.25rem;
  }

  .topMenu .btn {
    font-size: 0.875rem;
    padding: 0.25rem 0.5rem;
    margin: 0 !important;
  }

  .mr-2 {
    margin-right: 0 !important;
  }
}

/* Additional support for 320px viewport (WCAG reflow) */
@media (max-width: 320px) {
  .topMenu .btn {
    font-size: 0.8rem;
    padding: 0.2rem 0.4rem;
  }
}
</style>
